import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SingleBusinessReport from "./singleReport";
import SingleWidgetList from "./singleWidgetList";
import BusinessProfile from "./businessProfile";
import SingleSidebarMenu from "../menu/singleSidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { SingleBusinessData } from "../../../store/actions/new/businessAction";
import { useParams } from "react-router-dom";

const SingleBusiness = () => {

    const { id } = useParams();

    const businessState = useSelector((state) => state.businessAllData);
    const { singleBusiness } = businessState;
    const dispatch = useDispatch();
    useEffect(() => {
            dispatch(SingleBusinessData(id));
    }, [id]);

    return (
        <div className="business-wrapper sidebar-menu-enable">
            <Helmet title="New Business" />
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SingleSidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header">
                        <h3>Profile</h3>
                    </div>
                    <BusinessProfile  data={singleBusiness} />
                    <SingleBusinessReport />
                    <SingleWidgetList data={singleBusiness}/>
                </div>
            </div>
        </div>

    );
}

export default SingleBusiness;